<template>
  <el-menu-item v-if="!hasChildren" :index="item[field.id]">
    <span slot="title">{{ item[field.label] }}</span>
  </el-menu-item>
  <el-submenu v-else :index="item[field.id]">
    <span slot="title">{{ item[field.label] }}</span>
    <template v-for="subItem in item[field.children]">
      <MenuItem :item="subItem" :key="subItem[field.id]" />
    </template>
  </el-submenu>
</template>

<script>
import { isArray } from '@/utils/is';

export default {
  name: 'MenuItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasChildren() {
      const children = this.item.children;
      return isArray(children) && children.length;
    }
  },
  data() {
    return {
      field: {
        id: 'id',
        label: 'name',
        children: 'children'
      }
    };
  }
};
</script>
